var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('iframe',{attrs:{"src":"https://www.tidiochat.com/chat/zspemlh8nl3kx1g0e4axavmyxwfr3qe7?__hstc=183429753.9b64cdda066ce2f12d2eb88a98227232.1516806982927.1518812130490.1519051906482.23&__hssc=183429753.3.1519051906482&__hsfp=3687069429","width":"100%"}})])])])
}]

export { render, staticRenderFns }